import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { OverlayModule } from '@angular/cdk/overlay';
import { LayoutModule } from '@angular/cdk/layout';
import { TranslateModule } from '@ngx-translate/core';

import { SelectLanguageComponent } from './select-language.component';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [SelectLanguageComponent],
  imports: [CommonModule, PipesModule, ScrollingModule, TranslateModule, OverlayModule, LayoutModule],
  exports: [SelectLanguageComponent]
})
export class SelectLanguageModule {}
